<template>
  <div class="setting" style="height: 100%; display: flex; flex-direction: column">
    <hsq-panel>
      设置升级信息
      <updateInfoSetting slot="content" @code-change="handleCodeChange" @clear-code="handleClearCode"></updateInfoSetting>
    </hsq-panel>
    <hsq-panel style="margin-top: 16px; display:flex; flex-direction: column; flex-grow: 1">
      {{codeTitle}}
      <Input slot="content" readonly style="height: 100%" class="textString" v-model="codeString" type="textarea" placeholder="显示已上传的代码"></Input>
    </hsq-panel>
  </div>
</template>

<script>
// @ is an alias to /src
import updateInfoSetting from "../components/updateInfoSetting";
import hsqPanel from "../components/hsqPanel";

export default {
  name: 'setting',
  components: {
    updateInfoSetting,
    hsqPanel
  },
  computed: {
    codeTitle() {
      let result = '已上传代码';
      let code = this.code;
      if (code && code.length) {
        let length = code.length;
        result += ' - ' + length/2 + '字节';
      }

      return result;
    },
    codeString() {
      let code = this.code;
      if (code && code.length > 0) {
        return code;
      } else {
        return '';
      }
    }
  },
  data() {
    return {
      code: ''
    }
  },
  created() {
    this.code = this.$coreData.updateInfo.codeString;
  },
  destroyed() {
    console.log('destroyed');
    console.log(this.$coreData.updateResult);
  },
  methods: {
    handleCodeChange() {
      this.code = this.$coreData.updateInfo.codeString;
    },
    handleClearCode() {
      this.code = '';
    }
  }
}
</script>

<style>
.textString textarea {
  height: 100% !important;
}
</style>
